import React, { useState, useCallback, useEffect } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { IKeyword } from '../models/IKeyword';
import IKeywordSearchDropdownProps from '../models/IKeywordSearchDropdownProps';

const KeywordSearchDropdown: React.FC<IKeywordSearchDropdownProps> = ({
  getSelectedKeywords,
  label,
  keywordsData,
}) => {
  const [selectedKeywords, setSelectedKeywords] = useState<IKeyword[]>([]);
  const [filteredKeywordsData, setFilterdKeywordsData] = useState<IKeyword[]>(
    []
  );

  useEffect(() => {
    setFilterdKeywordsData(
      Array.isArray(keywordsData)
        ? keywordsData.filter(
            (keyword: IKeyword) => typeof keyword.title === 'string'
          )
        : []
    );
  }, [keywordsData]);

  // Memoize the keyword change handler
  const handleKeywordChange = useCallback(
    (_: React.ChangeEvent<unknown>, value: IKeyword[]) => {
      setSelectedKeywords(value);
      getSelectedKeywords(value);
    },
    [getSelectedKeywords]
  );

  // Memoize the filter function to prevent recreation on every render
  const memoizedFilterOptions = useCallback(
    (options: IKeyword[], { inputValue }: { inputValue: string }) => {
      return options
        .filter((option) =>
          option.title.toLowerCase().startsWith(inputValue.toLowerCase())
        )
        .slice(0, 200);
    },
    []
  );

  return (
    <div style={{ marginTop: '10px' }}>
      <Autocomplete
        multiple
        options={filteredKeywordsData}
        getOptionLabel={(option) => option.title}
        value={selectedKeywords}
        onChange={handleKeywordChange}
        filterOptions={memoizedFilterOptions}
        filterSelectedOptions
        renderInput={(params) => (
          <TextField
            {...params}
            variant='outlined'
            label={label}
            placeholder='Search and select research interests'
            helperText='Choose at least one research interest to personalize your Athena experience.'
          />
        )}
      />
    </div>
  );
};
const MemoizedKeywordSearchDropdown = React.memo(KeywordSearchDropdown);

// Export the named component
export default MemoizedKeywordSearchDropdown;
